import React from 'react'
import { Tag } from 'antd'

// Task007: etiquetas y utilidades del módulo de cobros, compartidas por la ficha del clon, Home y Cobros.

export const BILLING_STATES = {
  pending:   'Sin configurar',
  active:    'Activo',
  exempt:    'Exento (demo / gratis)',
  suspended: 'Suspendido',
  closed:    'De baja'
}
export const PLANS   = { web: 'Solo Web', web_mobile: 'Web + Móvil', partner: 'Plan Partner' }
export const PERIODS = { monthly: 'Mensual', annual: 'Anual' }

// "2026-11-15" → "15/11/2026". No pasa por Date: new Date('2026-11-15') se interpreta en UTC y en Lima da el 14
export const fmtDay = (s) => {
  if ( !s ) { return '—' }
  const [y, m, d] = String(s).slice(0, 10).split('-')
  return d + '/' + m + '/' + y
}

// Revisión 5: fecha con hora (chargeSentAt, suspendedAt). fmtDay tomaría el día en UTC: un cobro marcado a las 19:30
// de Lima saldría con el día siguiente
export const fmtStamp = (ts) => ts
  ? new Date(ts).toLocaleDateString('es-PE', { timeZone: 'America/Lima', day: '2-digit', month: '2-digit', year: 'numeric' })
  : '—'

export const fmtMoney = (amount, currency) =>
  amount === null || amount === undefined ? '—' : ( currency || 'USD' ) + ' ' + Number(amount).toFixed(2)

// { USD: 120, PEN: 50 } → "USD 120.00 + PEN 50.00"; vacío → "—"
export const fmtMoneyMap = (map) => {
  const parts = Object.keys(map || {}).map( cur => fmtMoney(map[cur], cur) )
  return parts.length ? parts.join(' + ') : '—'
}

// misma lógica que routes/modules/billingRules.js del backend (Lima = UTC-5 todo el año, sin horario de verano).
// Se repite acá solo para precargar el modal "Registrar pago"; el servidor valida y es la fuente de verdad.
export const todayLima = () => new Date(Date.now() - 5 * 3600 * 1000).toISOString().slice(0, 10)
export const addMonths = (s, n) => {
  const [y, m, d] = s.split('-').map(Number)
  const first = new Date(Date.UTC(y, m - 1 + n, 1))
  const last  = new Date(Date.UTC(first.getUTCFullYear(), first.getUTCMonth() + 1, 0)).getUTCDate()
  first.setUTCDate(Math.min(d, last))
  return first.toISOString().slice(0, 10)
}

// etiqueta de color con el estado de cobro derivado (`due`, lo calcula el backend)
export const dueTag = (due) => {
  if ( !due ) { return null }
  const map = {
    ok:          ['green',   'Al día · vence en ' + due.daysToDue + ' d'],
    due_soon:    ['gold',    'Vence en ' + due.daysToDue + ' d'],
    due_today:   ['orange',  'Vence hoy'],
    overdue:     ['red',     'Vencido hace ' + due.daysOverdue + ' d'],
    suspend_now: ['red',     'Vencido hace ' + due.daysOverdue + ' d · suspender'],
    delete_soon: ['magenta', due.daysToDelete > 0 ? 'Eliminar en ' + due.daysToDelete + ' d' : 'Eliminar ya'],
    suspended:   ['default', 'Suspendido'],
    pending:     ['default', 'Sin configurar'],
    no_date:     ['default', 'Sin vencimiento'],
    exempt:      ['default', 'Exento'],
    closed:      ['default', 'De baja']
  }
  const [color, text] = map[due.status] || ['default', due.status]
  return <Tag color={color} style={{ marginInlineEnd: 0 }}>{text}</Tag>
}
